// extracted by mini-css-extract-plugin
export default {"download":"AttachmentsContent_download__nZcyx","attachmentThumbnail":"AttachmentsContent_attachmentThumbnail__ilYx8"};